import React from 'react';
import {
  AppBar,
} from '@material-ui/core';
import { globalDateEntity } from '../../../constants/applicationConstants';
import styles from './footer.module.scss';

const Footer = () => {
  return(
    <AppBar position="static" className={styles['footer']}>
      <p>{globalDateEntity.footerText}</p>
    </AppBar>
  );
};

export default Footer;
